import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles(() => ({
  overlayGradient: {
    animation: 'fade-in-half 0.4s ease-out 0.2s forwards',
    background: `linear-gradient(to bottom, var(--primary-main), transparent)`,
    opacity: 0,
    width: '100%',
    height: '40vh',
    position: 'absolute',
    left: 0,
    top: 0,
    zIndex: 0,
    pointerEvents: 'none',
  },

  '@global': {
    '@keyframes fade-in-half': {
      from: {
        opacity: 0,
      },
      to: {
        opacity: '0.5',
      },
    },
  },
}));

export default useStyles;
